import { useEffect, useState } from "react";
import { useErrorBoundary } from "react-error-boundary";
import { axiosSakusas } from "common/api/axios/sakusas_axios";

const SakusasStart = () => {
  const { showBoundary } = useErrorBoundary();
  const [msgAuthRequiredSakusas, setMsgAuthRequiredSakusas] = useState<any>(
    "sakusas not accessed"
  );
  useEffect(() => {
    axiosSakusas
      .get("auth/authrequired")
      .then((res) => {
        setMsgAuthRequiredSakusas(res.statusText);
        setTimeout(() => {}, 2000);
      })
      .catch((err) => {
        console.log("sakusas res authrequired err", err.response.status);
      });
  }, []);

  return (
    <div>
      <div>START</div>
      <div>Sakusas: {msgAuthRequiredSakusas}</div>
    </div>
  );
};

export default SakusasStart;
